import { render, staticRenderFns } from "./Lookup.vue?vue&type=template&id=bfac6574&scoped=true"
import script from "./Lookup.vue?vue&type=script&lang=js"
export * from "./Lookup.vue?vue&type=script&lang=js"
import style0 from "./Lookup.vue?vue&type=style&index=0&id=bfac6574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfac6574",
  null
  
)

export default component.exports